<div class="spinner"></div>
<span class="label">Loading...</span>
